var render = function render(){var _vm=this,_c=_vm._self._c;return _c('diffInput',{attrs:{"optList":_vm.List,"title":_vm.$t('operations.products.modal.type'),"type":"select"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }